import BasicModel from '../basic/BasicModel'

export default {
  authStation (vm, params, listener) {
    let action = 'gasStation/authGasStation.action'
    BasicModel.post(vm, action, params, listener)
  },
  changeGasStatus (vm, params, listener) {
    let action = 'gasStation/changeGasStatus.action'
    BasicModel.post(vm, action, params, listener)
  },
  selectGasOrderData (vm, params, listener) {
    let action = 'gasStation/selectGasOrderData.action'
    BasicModel.get(vm, action, params, listener)
  }

}
